import React, { Fragment, useEffect } from "react";
import "../../utils/select2_multilocation_4.0.js";
import $ from 'jquery';
import "../../assets/VagaroStyle/select2.css"
import { utils } from "utils/Utils.js";

const MultiSelectBusiness = (props) => {

    const Control = { ControlID: "#" + props.ControlID }

    const SelectionType = { Select: 1, Deselect: 2, Opening: 3 };

    const resetOnClickValue = $("#resetBtnClickCustome").val();

    const OpenMultiSelect = () => {

        let openMultiSelectDefaultSelected = {};

        openMultiSelectDefaultSelected.tempSelectedItems = $('#' + props.ControlID).val();
        openMultiSelectDefaultSelected.findSelectedItem = $("#" + props.ControlID + " option:selected");
        openMultiSelectDefaultSelected.isDefaultSelectedClass = $('label[data-isDefault=true]').first().parent();
        openMultiSelectDefaultSelected.findDefaultSelectedClass = openMultiSelectDefaultSelected.isDefaultSelectedClass.find("label");
        openMultiSelectDefaultSelected.parentSelectedElements = "";
        openMultiSelectDefaultSelected.isChanges = false;
        openMultiSelectDefaultSelected.firstLoadSelectedItems = $("#" + props.ControlID + " option:selected");
        openMultiSelectDefaultSelected.firstLoadSelectedTempIems = [];

        openMultiSelectDefaultSelected.findSelectedItem.each(function () {
            openMultiSelectDefaultSelected.tempSelectedItems.push($(this).val());
        });


        if (
            (openMultiSelectDefaultSelected.findDefaultSelectedClass.length > 0)
            && (openMultiSelectDefaultSelected.findDefaultSelectedClass[0].dataset.isdefault === 'true')
        ) {


            openMultiSelectDefaultSelected.defaultSelectedBusiness = openMultiSelectDefaultSelected.findDefaultSelectedClass[0].dataset.isdefaultid;
            openMultiSelectDefaultSelected.findParentLabel = openMultiSelectDefaultSelected.parentLabel = $('label[data-is-parent=true][data-parent=' + openMultiSelectDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + ']').first().parent();
            openMultiSelectDefaultSelected.parentSelectedElements = $('select#' + props.ControlID).find("option:selected[data-parent=" + openMultiSelectDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + "][data-is-parent=false]");

            if (openMultiSelectDefaultSelected.findParentLabel.length > 0) {

                openMultiSelectDefaultSelected.parentLabelDataset = openMultiSelectDefaultSelected.findParentLabel.find("label");
                openMultiSelectDefaultSelected.parentLabelId = openMultiSelectDefaultSelected.parentLabelDataset[0].dataset.isdefaultid;
            }

            if (openMultiSelectDefaultSelected.tempSelectedItems.find((i) => i === openMultiSelectDefaultSelected.parentLabelId) === undefined) {

                openMultiSelectDefaultSelected.tempSelectedItems.push(openMultiSelectDefaultSelected.parentLabelId);
            }


            if (openMultiSelectDefaultSelected.tempSelectedItems.find((i) => i === openMultiSelectDefaultSelected.defaultSelectedBusiness) === undefined) {
                openMultiSelectDefaultSelected.tempSelectedItems.push(openMultiSelectDefaultSelected.defaultSelectedBusiness);
            }

            if (openMultiSelectDefaultSelected.parentSelectedElements.length > 0) {

                openMultiSelectDefaultSelected.parentLabel.find("span.multicheck-checkbox").addClass("default-selected");
            } else {

                openMultiSelectDefaultSelected.parentLabel.attr("aria-selected", "true");
            }

            $('#' + props.ControlID).val(openMultiSelectDefaultSelected.tempSelectedItems).trigger('change');

        } else {

            openMultiSelectDefaultSelected.firstLoadSelectedItems.each(function () {
                openMultiSelectDefaultSelected.firstLoadSelectedTempIems.push($(this).val());
            });

            $('#' + props.ControlID).val(openMultiSelectDefaultSelected.firstLoadSelectedTempIems).trigger('change');
        }

        $('.select2-container').addClass("driveFormMselect datepicker-width");
        $('.select2-container').addClass(props.ControlID);
        $(' .selectall').addClass("AllCustomer");
        $('.driveFormMselect .selectnone').addClass("NoneCustomer");

        $(".NoneCustomer").on("click", function () {

            $(Control.ControlID).select2("val", "");

            let onChangeDefaultSelected = {};

            onChangeDefaultSelected.tempSelectedItems = [];
            onChangeDefaultSelected.findSelectedItem = $("#" + props.ControlID + " option:selected");
            onChangeDefaultSelected.isDefaultSelectedClass = $('label[data-isDefault=true]').first().parent();
            onChangeDefaultSelected.findDefaultSelectedClass = onChangeDefaultSelected.isDefaultSelectedClass.find("label");
            onChangeDefaultSelected.isChanges = false;

            onChangeDefaultSelected.findSelectedItem.each(function () {
                onChangeDefaultSelected.tempSelectedItems.push($(this).val());
            });

            if (
                (onChangeDefaultSelected.findDefaultSelectedClass.length > 0)
                && (onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.isdefault === 'true')
            ) {

                onChangeDefaultSelected.defaultSelectedBusineeId = onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.isdefaultid;
                onChangeDefaultSelected.findParentLabelId = $('label[data-is-parent=true][data-parent=' + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + ']').first().parent();
                onChangeDefaultSelected.parentLabel = $('label[data-is-parent=true][data-parent=' + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + ']').first().parent();
                onChangeDefaultSelected.parentSelectedElements = $('select#' + props.ControlID).find("option:selected[data-parent=" + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + "][data-is-parent=false]");

                if (onChangeDefaultSelected.findParentLabelId.length > 0) {

                    onChangeDefaultSelected.findParentLabelId = onChangeDefaultSelected.findParentLabelId.find("label");
                    onChangeDefaultSelected.findParentId = onChangeDefaultSelected.findParentLabelId[0].dataset.isdefaultid;
                }

                if (onChangeDefaultSelected.tempSelectedItems.find((i) => i === onChangeDefaultSelected.findParentId) === undefined) {

                    onChangeDefaultSelected.findParentLabelId.find("span.multicheck-checkbox").addClass("default-selected");
                }

                if (onChangeDefaultSelected.tempSelectedItems.find((i) => i === onChangeDefaultSelected.defaultSelectedBusineeId) === undefined) {

                    onChangeDefaultSelected.tempSelectedItems.push(onChangeDefaultSelected.defaultSelectedBusineeId);
                    onChangeDefaultSelected.isChanges = true;
                }
            }
        });

        $("body").append('<div class="select2backdrop ' + props.ControlID + '"></div>');
        $('.select2backdrop').on('click', function () {
            $(Control.ControlID + '.expandedWidth').select2("close");
        });
    };

    const CloseMultiSelect = () => {
        $('.select2backdrop ').hide().remove();
        $('.select2-container').removeClass("driveFormMselect");
    }



    const OnChangeMultiSelect = () => {

        let onChangeDefaultSelected = {};

        onChangeDefaultSelected.tempSelectedItems = [];
        onChangeDefaultSelected.findSelectedItem = $("#" + props.ControlID + " option:selected");
        onChangeDefaultSelected.isDefaultSelectedClass = $('label[data-isDefault=true]').first().parent();
        onChangeDefaultSelected.findDefaultSelectedClass = onChangeDefaultSelected.isDefaultSelectedClass.find("label");
        onChangeDefaultSelected.isChanges = false;
        onChangeDefaultSelected.optionSelectedLength = [];
        onChangeDefaultSelected.totalOption = [];

        onChangeDefaultSelected.findSelectedItem.each(function () {
            onChangeDefaultSelected.tempSelectedItems.push($(this).val());
        });

        if (
            (onChangeDefaultSelected.findDefaultSelectedClass.length > 0)
            && (onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.isdefault === 'true')
        ) {

            onChangeDefaultSelected.defaultSelectedBusineeId = onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.isdefaultid;
            onChangeDefaultSelected.findParentLabelId = $('label[data-is-parent=false][data-parent=' + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + ']').first().parent();
            onChangeDefaultSelected.parentLabel = $('label[data-is-parent=true][data-parent=' + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + ']').first().parent();
            onChangeDefaultSelected.parentSelectedElements = $('select#' + props.ControlID).find("option:selected[data-parent=" + onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent.replaceAll(' ','-') + "][data-is-parent=false]");
            onChangeDefaultSelected.parentSelectedElementsAfter = $('select#' + props.ControlID).find("option:selected");
            onChangeDefaultSelected.parentSelectedElementsBefore = $('select#' + props.ControlID).find("option");


            if (onChangeDefaultSelected.parentSelectedElementsAfter.length > 0) {

                for (let index = 0; index < onChangeDefaultSelected.parentSelectedElementsAfter.length; index++) {

                    if (onChangeDefaultSelected.parentSelectedElementsAfter[index].dataset.parent === onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent) {

                        onChangeDefaultSelected.optionSelectedLength.push(onChangeDefaultSelected.parentSelectedElementsAfter[index].dataset.isparentid)
                    }

                }
            }

            if (onChangeDefaultSelected.parentSelectedElementsBefore.length > 0) {

                for (let index = 0; index < onChangeDefaultSelected.parentSelectedElementsBefore.length; index++) {

                    if (onChangeDefaultSelected.parentSelectedElementsBefore[index].dataset.parent === onChangeDefaultSelected.findDefaultSelectedClass[0].dataset.parent) {

                        onChangeDefaultSelected.totalOption.push(onChangeDefaultSelected.parentSelectedElementsBefore[index].dataset.isparentid)
                    }
                }
            }

            if (onChangeDefaultSelected.findParentLabelId.length > 0) {

                onChangeDefaultSelected.findParentLabelId = onChangeDefaultSelected.findParentLabelId.find("label");
                onChangeDefaultSelected.findParentId = onChangeDefaultSelected.findParentLabelId[0].dataset.isdefaultid;
            }

            if (onChangeDefaultSelected.tempSelectedItems.find((i) => i === onChangeDefaultSelected.findParentId) === undefined) {

                onChangeDefaultSelected.findParentLabelId.find("span.multicheck-checkbox").addClass("default-selected");
            }

            if (onChangeDefaultSelected.tempSelectedItems.find((i) => i === onChangeDefaultSelected.defaultSelectedBusineeId) === undefined) {

                onChangeDefaultSelected.tempSelectedItems.push(onChangeDefaultSelected.defaultSelectedBusineeId);
                onChangeDefaultSelected.isChanges = true;
            }


            if (onChangeDefaultSelected.optionSelectedLength.length !== onChangeDefaultSelected.totalOption.length) {

                onChangeDefaultSelected.parentLabel.find("span.multicheck-checkbox").addClass("multicheck-deselect-checkbox");
            } else {
                
                onChangeDefaultSelected.findParentLabelId.attr("aria-selected", "true");
                onChangeDefaultSelected.parentLabel.find("span.multicheck-checkbox").removeClass("multicheck-deselect-checkbox");
            }

            onChangeDefaultSelected.findParentLabelId.parent().parent().parent().addClass("res-tooltip-setting");
        }

        onChangeDefaultSelected.selectedDefaultValues = $('#' + props.ControlID).val();
        onChangeDefaultSelected.filterParentIds = onChangeDefaultSelected.selectedDefaultValues.filter(item => !item.includes('parent'));

        if (onChangeDefaultSelected.isChanges === true) {

            $('#' + props.ControlID).val(onChangeDefaultSelected.tempSelectedItems).trigger('change');
        } else {

            props.onChange(onChangeDefaultSelected.filterParentIds.join(','));
        }
    }

    const ApplySelect2 = () => {
        $(Control.ControlID).select2({
            placeholder: props.placeholder,
            dropdownAutoWidth: true,
            width: '100%',
            isCountOnlyChild: 1,
            templateResult: function (obj) {
                let $obj = "";
                if (obj.element !== undefined && obj.element !== null) {

                    if ($(obj.element).attr("class") === "parent_p") {

                        $obj = $(
                            '<span class="multicheck-checkbox' + ($(obj.element).data("is-parent-selected") === false ? 'multicheck-deselect-checkbox' : '') + '"></span><label class="labelpadd parent" data-isDefaultId=' + obj.id + ' data-is-parent=true data-parent="' + $(obj.element).data("parent") + '">' + obj.text + '</label>'
                        );
                    } else {
                        var marginleft = 30;
                        if(obj.element.dataset.isparent == "true" && obj.element.dataset.groupid == "false") {
                            marginleft = 0;
                        }   

                        if (obj.element.dataset.isdefault === 'true') {

                            if(obj.element.dataset.isdefault)
                            $obj = $(
                                '<div class="' + (marginleft > 0 ? "res-tooltip-setting default-selected" : "") + '"><span class="' + (marginleft > 0 ? "resIsymbol" : "") + '"><span class="multicheck-checkbox" style="' + (marginleft > 0 ? "margin-left:18px;" : "") + '"></span><label style="margin-left:' + marginleft + 'px;" data-isDefault=' + obj.element.dataset.isdefault + ' data-isDefaultId=' + obj.id + ' class="labelpadd" data-is-parent=false data-parent="' + $(obj.element).data("parent") + '">' + obj.text + '</label></span><div class="resIsymbol-msg">This business activated MySite and cannot be deselected.</div></div>'
                            );
                        } else {

                            $obj = $(
                                '<span class="multicheck-checkbox" style="margin-left:' + marginleft + 'px;"></span><label style="margin-left:' + marginleft + 'px;" data-isDefault=' + obj.element.dataset.isdefault + ' data-isDefaultId=' + obj.id + ' class="labelpadd" data-is-parent=false data-parent="' + $(obj.element).data("parent") + '">' + obj.text + '</label>'
                            );
                        }
                    }
                } else {

                    $obj = $(
                        '<span class="multicheck-checkbox"></span><label class="labelpadd">' + obj.text + '</label>'
                    );
                }
                return $obj;
            },
            selectAll: 1,
            closeOnSelect: false,
            searchInputPlaceholder: props.searchInputPlaceholder,
            matcher: smartSearch
        }).on('select2:opening', function (e) {
        }).on('select2:closing', function (e) {
        }).on('select2:select', function (e) {
            SelectDeSelectOptions(e, SelectionType.Select);
        }).on('select2:unselect', function (e) {
            SelectDeSelectOptions(e, SelectionType.Deselect);
        })
    }


    const smartSearch = (params, data) => {
        if (typeof (params.term) == 'undefined' || params.term == null || params.term == "") {
            return data;
        } else {

            let smartSearchData = {};
            smartSearchData.search = $.trim(params.term).toLowerCase();
            smartSearchData.searching = smartSearchData.search.split(' ');
            smartSearchData.optionList = data.text.toLowerCase();
            smartSearchData.parentOptionList = data.element.dataset.parent.toLowerCase();


            if (
                (smartSearchData.optionList.indexOf(smartSearchData.searching) > -1)
                || (smartSearchData.parentOptionList.indexOf(smartSearchData.searching) > -1)
            ) {
                return data;
            } else {
                smartSearchData.childWiseFilter = props.options.filter((d) => d.parentId.toString() === data.element.dataset.parent);
                smartSearchData.datamatched = smartSearchData.childWiseFilter.some((s) => (smartSearchData.searching.filter((txt) => s.label.toLowerCase().includes(txt)).length === smartSearchData.searching.length))

                if (smartSearchData.datamatched === true) {
                    if (data.element.dataset.isParent === 'true') {
                        return data;
                    } else {
                        if (!smartSearchData.searching.map(val => (data.text || "").toLocaleLowerCase().includes(val)).includes(false)) {
                            return data;
                        }
                    }
                }
            }
        }
        return null;
    }


    const SelectDeSelectOptions = (e, type) => {

        let selectDeselectOptions = {};

        selectDeselectOptions.ddMultiGroupSelect = $('select#' + props.ControlID);
        selectDeselectOptions.parentId = $(e.params.data.element).data("parent");
        selectDeselectOptions.parentId = (selectDeselectOptions.parentId?selectDeselectOptions.parentId.replaceAll(' ','-'):"");
        selectDeselectOptions.isParentClass = $(e.params.data.element).attr("class") === "parent_p";
        selectDeselectOptions.allParentElements = selectDeselectOptions.ddMultiGroupSelect.find("option[data-parent=" + selectDeselectOptions.parentId + "]");
        selectDeselectOptions.parentLabel = $('label[data-is-parent=true][data-parent=' + selectDeselectOptions.parentId + ']').first().parent();
        selectDeselectOptions.parentSelectedElements = selectDeselectOptions.ddMultiGroupSelect.find("option:selected[data-parent=" + selectDeselectOptions.parentId + "][data-is-parent=false]");
        selectDeselectOptions.childElements = $.grep(selectDeselectOptions.allParentElements, function (n) { return ($(n).data("is-parent") === false); });
        selectDeselectOptions.parentIdFind = $('label[data-is-parent=true][data-parent=' + selectDeselectOptions.parentId + ']').first().parent();
        selectDeselectOptions.isChildSelectedParentId = "";
        selectDeselectOptions.selectedItems = $(Control.ControlID).val() == null ? [] : $(Control.ControlID).val();
        selectDeselectOptions.parentLabel.find("span.multicheck-checkbox").removeClass("multicheck-deselect-checkbox");

        if (type === SelectionType.Select) {

            if (selectDeselectOptions.isParentClass === true) {

                selectDeselectOptions.allParentElements.first().data("is-parent-selected", true);

                if (!($.inArray($(e.params.data.element).val(), selectDeselectOptions.selectedItems) !== -1)) {
                    selectDeselectOptions.selectedItems.push($(e.params.data.element).val());
                }

                $('label[data-parent=' + selectDeselectOptions.parentId + ']').parent().attr("aria-selected", "true");
                $(selectDeselectOptions.childElements).each(function (i, item) { selectDeselectOptions.selectedItems.push($(item).val()); });
            } else {

                if (selectDeselectOptions.parentIdFind.length > 0) {

                    selectDeselectOptions.isChildSelectedParentId = selectDeselectOptions.parentIdFind.find("label");

                    if (!($.inArray(selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid, selectDeselectOptions.selectedItems) !== -1)) {
                        selectDeselectOptions.selectedItems.push(selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid);
                    }
                }

                selectDeselectOptions.parentLabel.attr("aria-selected", "true");

                if (
                    selectDeselectOptions.childElements != null
                    && selectDeselectOptions.parentSelectedElements != null
                    && (selectDeselectOptions.childElements.length === selectDeselectOptions.parentSelectedElements.length)
                ) {


                    selectDeselectOptions.allParentElements.first().data("is-parent-selected", true);
                    $('label[data-parent=' + selectDeselectOptions.parentId + ']').parent().attr("aria-selected", "true");

                    $(selectDeselectOptions.childElements).each(function (i, item) {
                        selectDeselectOptions.selectedItems.push($(item).val());
                    });

                } else {

                    if (selectDeselectOptions.parentSelectedElements.length > 0) {

                        selectDeselectOptions.parentLabel.find("span.multicheck-checkbox").addClass("multicheck-deselect-checkbox");
                    } else {

                        selectDeselectOptions.parentLabel.attr("aria-selected", "false");
                        $('label[data-parent=' + selectDeselectOptions.parentId + ']').parent().attr("aria-selected", "false");


                        if (selectDeselectOptions.parentIdFind.length > 0) {

                            selectDeselectOptions.isChildSelectedParentId = selectDeselectOptions.parentIdFind.find("label");

                            if (!($.inArray(selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid, selectDeselectOptions.selectedItems) !== -1)) {

                                selectDeselectOptions.selectedItems = $.grep(selectDeselectOptions.selectedItems, function (n) {
                                    return n !== selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid;
                                });
                            }
                        }
                    }
                }
            }
        } else if (type === SelectionType.Deselect) {

            if (selectDeselectOptions.isParentClass === true) {

                $('label[data-parent=' + selectDeselectOptions.parentId + ']').parent().attr("aria-selected", "false");

                $(selectDeselectOptions.allParentElements).each(function (i, item) {
                    let removeItem = $(item).val();

                    selectDeselectOptions.selectedItems = $.grep(selectDeselectOptions.selectedItems, function (n) {
                        return n !== removeItem;
                    });
                });

                if (selectDeselectOptions.parentIdFind.length > 0) {

                    selectDeselectOptions.isChildSelectedParentId = selectDeselectOptions.parentIdFind.find("label");

                    if (!($.inArray(selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid, selectDeselectOptions.selectedItems) !== -1)) {

                        selectDeselectOptions.selectedItems = $.grep(selectDeselectOptions.selectedItems, function (n) {
                            return n !== selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid;
                        });
                    }
                }
            } else {

                if (
                    selectDeselectOptions.childElements != null
                    && selectDeselectOptions.parentSelectedElements != null
                    && (selectDeselectOptions.childElements.length !== selectDeselectOptions.parentSelectedElements.length)
                ) {

                    if (selectDeselectOptions.parentSelectedElements.length > 0) {

                        selectDeselectOptions.parentLabel.find("span.multicheck-checkbox").addClass("multicheck-deselect-checkbox");
                    } else {

                        selectDeselectOptions.parentLabel.attr("aria-selected", "false");
                        $('label[data-parent=' + selectDeselectOptions.parentId + ']').parent().attr("aria-selected", "false");

                        if (selectDeselectOptions.parentIdFind.length > 0) {

                            selectDeselectOptions.isChildSelectedParentId = selectDeselectOptions.parentIdFind.find("label");

                            if (selectDeselectOptions.isChildSelectedParentId.length > 0) {

                                selectDeselectOptions.selectedItems = selectDeselectOptions.selectedItems.filter(item => item !== selectDeselectOptions.isChildSelectedParentId[0].dataset.isdefaultid);
                            }
                        }
                    }
                }
            }
        }

        if (selectDeselectOptions.selectedItems.length > 0) {
            selectDeselectOptions.ddMultiGroupSelect.val(selectDeselectOptions.selectedItems).trigger("change");
        } else {
            selectDeselectOptions.parentLabel.attr("aria-selected", "false");
            selectDeselectOptions.ddMultiGroupSelect.val('').trigger("change");
        }
    }


    useEffect(() => {
        ApplySelect2();
        $(Control.ControlID).on("change", function (e) {
            OnChangeMultiSelect()
        })
        $(Control.ControlID + '.expandedWidth').on('select2:open', function (e) {
            OpenMultiSelect()
        })
        $(Control.ControlID + '.expandedWidth').on('select2:close', function (e) {
            CloseMultiSelect()
        });
    }, [props.placeholder]);

    useEffect(() => {

        ApplySelect2();

        let ddMultiGroupSelect = $('select#' + props.ControlID);
        if (utils.Validate(ddMultiGroupSelect)) {
            ddMultiGroupSelect.trigger("change");
        }
    }, [props.options]);

    useEffect(() => {
        if ($('#resetBtnClickCustome').val() === "1") {
            $('#resetBtnClickCustome').val("");
        }
    }, [resetOnClickValue])


    return (
        <Fragment>
            <div>
                <fieldset>
                    <select id={props.ControlID} className="expandedWidth vgselect-dropdown prosale-select2" multiple="true" data-select-all="1" >
                        {props.options.map((item) =>
                            <option selected={item.isSelected ? true : false} data-isDefault={item.isDefault} data-isParentId={item.value} data-isParent={item.isParent} data-isDefaultId={item.value} className={item.groupName === true ? "parent_p" : "child_p"} data-parent={item.parentId.replaceAll(" ","-")} value={item.value} data-is-parent={item.groupName === true ? true : false} data-groupId={item.groupName}>{item.label}</option>
                        )};
                    </select>
                </fieldset>
            </div>
        </Fragment>
    )

};

export default MultiSelectBusiness;